import React, { useEffect, useMemo } from "react";
import ReactEcharts, { EChartsOption } from "echarts-for-react";
import { DashboardVars, GetDashboardJunctionCountData } from "../../types";
import { useLazyQuery } from "@apollo/client";
import { GetDashboardJunctionCount } from "../../queries";
import useUrlParams from "../../../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../../../customHooks/useLoggedInUserDetails";
import { Title } from "../../../../../../../stories/Title/Title";
import useLabels from "../../../../../../../customHooks/useLabels";
import { TEXT_FONT_FAMILY } from "../../../../../../../styles/Variables";

const VendorDetailsGraph: React.FC = () => {
  const { ledgerLabel } = useLabels();
  const { customer_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();
  const [GetDashboardItems, { data }] = useLazyQuery<
    GetDashboardJunctionCountData,
    DashboardVars
  >(GetDashboardJunctionCount);
  useEffect(() => {
    if (customer_id || user_details.id) {
      GetDashboardItems({
        variables: {
       
          customerID: customer_id ? customer_id : 0,
          empID: user_details.id ? user_details.id : 0
        }
      });
    }
  }, [customer_id, user_details.id, GetDashboardItems]);

  const datasetSource = useMemo(() => {
    const vendorData =
      (data && data.GetDashboardJunctionCount.vendorWiseData) || [];

    return [
      ["Vendor Name", "Total", "Working", "Not Working"], // Headers
      ...vendorData.map((vendor) => [
        vendor.vendorName,
        vendor.total,
        vendor.working,
        vendor.notWorking
      ])
    ];
  }, [data]);

  const option: EChartsOption = {
    legend: {
      bottom: 0,
      orient: "horizontal",
      itemGap: 20,
      textStyle: {
        fontSize: 12,
        color: "#333",
        fontFamily: TEXT_FONT_FAMILY
      }
    },
    tooltip: {},
    dataset: { source: datasetSource },

    xAxis: {
      type: "category",
      axisLabel: {
        fontSize: 12,
        color: "#333",
        fontFamily: TEXT_FONT_FAMILY
      }
    },
    yAxis: {
      axisLabel: {
        fontSize: 12,
        color: "#333",
        fontFamily: TEXT_FONT_FAMILY
      }
    },
    series: [
      {
        type: "bar",
        name: "Total",
        itemStyle: { color: "#0ea5e9", borderRadius: [6, 6, 0, 0] }
      },
      {
        type: "bar",
        name: "Working",
        itemStyle: { color: "#22c55e", borderRadius: [6, 6, 0, 0] }
      },
      {
        type: "bar",
        name: "Tickets Raised",
        itemStyle: { color: "#ef4444", borderRadius: [6, 6, 0, 0] }
      }
    ]
  };

  return (
    <div className="d-signal-details__vendor-graph">
      <Title variant="subtitle1">{ledgerLabel} wise count</Title>
      <ReactEcharts option={option} />
    </div>
  );
};

export default VendorDetailsGraph;
